// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import ViewUI from 'view-design';
import Viewer from 'v-viewer'
import 'element-ui/lib/theme-chalk/index.css'

import '@/assets/css/main.css'
import layer from "layui-layer";
import store from './store'
import '../static/ueditor//ueditor.config'
import '../static/ueditor/ueditor.all'
import '../static/ueditor/lang/zh-cn/zh-cn'
import '../static/ueditor/ueditor.parse.min'
import 'viewerjs/dist/viewer.css'
import './styles/index.less';
import '@/assets/icons/iconfont.css';
import '@/assets/iconfont/iconfont.css';
import 'view-design/dist/styles/iview.css';

Vue.config.productionTip = false
Vue.use(ViewUI);
Vue.use(ElementUI)
Vue.use(layer)
Vue.use(require('vue-moment'))
Vue.use(Viewer)
Viewer.setDefaults({
    Options: { 'inline': true, 'button': true, 'navbar': true, 'title': true, 'toolbar': true, 'tooltip': true, 'movable': true, 'zoomable': true, 'rotatable': true, 'scalable': true, 'transition': true, 'fullscreen': true, 'keyboard': true, 'url': 'data-source' }
})
Vue.component('has-qz-button', () => import('./components/permission/has-qx-button'));
Vue.component('has-qx-popconfirm', () => import('./components/permission/has-qx-popconfirm'));
Vue.component('has-qx-link', () => import('./components/permission/has-qx-link'));

//按扭权限指令
Vue.directive('allow', {
  inserted: (el, binding, vnode) => {
    let permissionList = store.getters.getPermissions;
    var btnPerms = binding.value;
    if (btnPerms) {
      var btnPermsArr = btnPerms.split(",");
       var flag = false;
      for (let i = 0; i < btnPermsArr.length; i++) {
        const element = btnPermsArr[i];
        if (("," + permissionList + ",").includes("," + element + ",")) {
          flag = true;
        }
      }
      if (!flag) {
        el.parentNode.removeChild(el);
      }
    }
  }
})
Vue.directive('allowNot', {
  inserted: (el, binding, vnode) => {
    let permissionList = store.getters.getPermissions;
    var btnPerms = binding.value;
    if (btnPerms) {
      var btnPermsArr = btnPerms.split(",");
       var flag = false;
      for (let i = 0; i < btnPermsArr.length; i++) {
        const element = btnPermsArr[i];
        if (("," + permissionList + ",").includes("," + element + ",")) {
          flag = true;
        }
      }
      if (flag) {
        el.parentNode.removeChild(el);
      }
    }
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js